import { Header } from '@components/Header';
import React from 'react';

const tooltip =
  'A client is anyone who partners with Bonsai using our product catalogue or checking out through our platform';

export const CreateClientHeader = () => <Header title="Create client" tooltip={tooltip} />;
